import { Box, Text, TextButton } from '@wix/design-system';
import { HirePartnerSection } from '@wix/wix-help-widget-common/homepage';
import { useTranslation } from '@wix/wix-i18n-config';
import React, { FC, useCallback } from 'react';

import { TLocalesKeys } from '../../../types';
import { biHelpCenter } from '../../../util/bi';
import s from '../styles.scss';
import { SectionComponentProps } from '../types';
import { HireProfessionalIconSvg } from './HireProfessionalIconSvg';

type HireProfessionalProps = SectionComponentProps<HirePartnerSection>;

const MARKETPLACE_URL = 'https://www.wix.com/marketplace';

export const HireProfessional: FC<HireProfessionalProps> = ({
  positionIndex,
  ctaContent,
  cta,
}) => {
  const { t } = useTranslation();

  const contentText =
    ctaContent ?? t<TLocalesKeys>('home_hire_professional_content_text');
  const buttonText = cta ?? t<TLocalesKeys>('home_hire_professional_button');

  const onClick = useCallback(() => {
    biHelpCenter.logHirePartnerButtonInteraction(
      MARKETPLACE_URL,
      buttonText,
      positionIndex,
    );
  }, [positionIndex, buttonText]);

  return (
    <a
      className={s.homepageActionItem}
      href={MARKETPLACE_URL}
      onClick={onClick}
      target="_blank"
      rel="noreferrer"
    >
      <Box gap={3} padding={3}>
        <HireProfessionalIconSvg />
        <Box direction="vertical" gap={1} verticalAlign="bottom" align="left">
          <Text size="small" secondary>
            {contentText}
          </Text>
          <TextButton size="small" weight="normal">
            {buttonText}
          </TextButton>
        </Box>
      </Box>
    </a>
  );
};
